
import { defineComponent, nextTick, reactive, ref, toRefs, watch } from "vue";
import { StateType } from "./previewVideo";
const states = {};
export default defineComponent({
  props: ["url", "visible", "autoplay"],
  setup(prop, { emit, slots }) {
    const stateData = reactive<StateType>(states);
    const videoRef: any = ref(null);
    // 弹出框关闭时，将视频停止掉
    watch(
      () => prop.visible,
      (v) => {
        if (!v) {
          videoRef.value.currentTime = 0;
          videoRef.value.pause();
        } else {
          nextTick(() => {
            videoRef.value.currentTime = 0;
            videoRef.value.play();
          });
        }
      }
    );
    return {
      ...toRefs(stateData),
      ...useEvent(stateData, emit),
      videoRef,
    };
  },
});
const useEvent = (state: StateType, emit: any) => {
  const onClickOverlay = () => {
    emit("update:visible", false);
  };
  return {
    onClickOverlay,
  };
};
